import Vue from 'vue'

import Form from './Form'
import FormItem from './FormItem'
import FormPartial from './FormPartial'

import DatePickerInput from './DatePickerInput'
import FormAddress from './FormAddress'
import FormAddressSummary from './FormAddressSummary'
import FormCheckbox from './FormCheckbox'
import FormFileInput from './FormFileInput'
import FormInput from './FormInput'
import FormRadio from './FormRadio'
import FormRepeater from './FormRepeater'
import FormSelect from './FormSelect'
import FormSwitch from './FormSwitch'
import FormTime from './FormTime'
import FormUppy from './FormUppy'

Vue.component('ui-form', Form)
Vue.component('ui-form-partial', FormPartial)
Vue.component('ui-form-address', FormAddress)
Vue.component('ui-form-address-summary', FormAddressSummary)
Vue.component('ui-form-file', FormFileInput)
Vue.component('ui-form-item', FormItem)
Vue.component('ui-form-input', FormInput)
Vue.component('ui-form-radio', FormRadio)
Vue.component('ui-form-repeater', FormRepeater)
Vue.component('ui-form-checkbox', FormCheckbox)
Vue.component('ui-form-select', FormSelect)
Vue.component('ui-form-switch', FormSwitch)
Vue.component('ui-form-time', FormTime)
Vue.component('ui-form-uppy', FormUppy)
Vue.component('ui-date-picker-input', DatePickerInput)
